import { useQuery } from "@tanstack/react-query";
import { getMyQuota } from "../actions/myquota.actions";

export const usePageBuilderMyQuotaQuery = () => {
    const myQuota = useQuery({
        queryKey: ["page-builder-my-quota"],
        queryFn: () => getMyQuota()
    });

    return myQuota;
};